__turbopack_context__.v({
  "childrenContainer": "FocusAreaItem-module-scss-module__IhG-bG__childrenContainer",
  "description": "FocusAreaItem-module-scss-module__IhG-bG__description",
  "descriptionContainer": "FocusAreaItem-module-scss-module__IhG-bG__descriptionContainer",
  "disabled": "FocusAreaItem-module-scss-module__IhG-bG__disabled",
  "expandButton": "FocusAreaItem-module-scss-module__IhG-bG__expandButton",
  "expandIcon": "FocusAreaItem-module-scss-module__IhG-bG__expandIcon",
  "expanded": "FocusAreaItem-module-scss-module__IhG-bG__expanded",
  "root": "FocusAreaItem-module-scss-module__IhG-bG__root",
});
